import {Injectable} from '@angular/core';
import {Http, Response, Headers} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { environment } from '../../../environments/environment';
import { ResCotizacion }    from '../../obj/resCotizacion';   
import { Poliza }    from '../../obj/poliza';   
import { CotizacionWeb }    from '../../obj/cotizacionWeb';   
import { Destinos } from 'app/obj/destinos';
import { TiposViaje } from 'app/obj/tiposViaje';

/*let tipo = [
      { id: 11, value: 'Estudio' },
      { id: 12, value: 'Larga Estadía (más de 60 días).' },
      { id: 13, value: 'Corta Estadia (menos de 60 días)' },      
      { id: 14, value: 'MultiViajes' },
      { id: 15, value: 'Estudio Con Responsabilidad Civil' },
      { id: 16, value: 'Futura Mamá' },
      { id: 17, value: 'Atención médica por Pre-existencia' },
      { id: 18, value: 'Seguro obligatorio Parques Nacionales' },
      { id: 20, value: 'Seguro de viaje para Deportistas' },
      { id: 21, value: 'Nacional (solo Colombianos o Residentes)' },
      { id: 22, value: 'Francia Turismo / Trabajo'}
    ];*/
let estadia = [
      { id: 1, value: 'Anual(máximo 30 días por Viaje)' },
      { id: 2, value: 'Anual(máximo 60 días por Viaje)' },
      { id: 3, value: 'Anual(máximo 90 días por Viaje)' }  
    ];
@Injectable()
export class CotizadorService {  

    public origen = [];
    public destino = [];
    public tipo = [];
  
    constructor(private http:Http) { }
    
    /*getTipo(){
      return new Promise(resolve => resolve(tipo));
    }*/

    getEstadia(){return new Promise(resolve => resolve(estadia));}  
    
    getResCotizacion(user:string): Promise<ResCotizacion>{        
      let headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
      let url=environment.serviceUrl+'poliza';
      
      return this.http
        .post(url, user,{headers: headers})
        .toPromise()
        .then(response => {
          return response.json() as ResCotizacion;
        })
        .catch(this.handleError)   
    }   

    getCotizacion(cot:string): Promise<CotizacionWeb>{    
      let headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
      let url=environment.serviceUrl+'cotizacion';
      return this.http
        .post(url, cot,{headers: headers})
        .toPromise()
        .then(
          response => {
            return response.json() as CotizacionWeb;
          })
        .catch(this.handleError)
    }    
    
    /**
   * Handles error thrown during HTTP call
   * @param error:any
   * @returns {Promise<never>}
   */
  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); //
    return Promise.reject(error.message || error);
  }

  getOrigen(){        
    let headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
    let url=environment.serviceUrl+'paises';

    return this.http
    .get(url, {headers: headers})
    .toPromise()
    .then(
      response => {
          return response.json() as Destinos;        
      },
      reject => {
          let origenes = [
            { id: 48, descripcion: 'Colombia' },
            { id: 1, descripcion: 'Aruba' },
            { id: 2, descripcion: 'Argentina' },
            { id: 6, descripcion: 'Alemania' },
            { id: 247, descripcion: 'Austria' },
            { id: 12, descripcion: 'Arabia Saudita' },
            { id: 15, descripcion: 'Aruba' },
            { id: 16, descripcion: 'Australia' },
            { id: 19, descripcion: 'Bahamas' },
            { id: 20, descripcion: 'Holanda' },
            { id: 21, descripcion: 'Barbados' },
            { id: 25, descripcion: 'Bemudas' },
            { id: 28, descripcion: 'Bolivia' },
            { id: 31, descripcion: 'Brasil' },
            { id: 33, descripcion: 'Bulgaria' },
            { id: 37, descripcion: 'Belgica' },
            { id: 38, descripcion: 'Cabo Verde' },
            { id: 39, descripcion: 'Islas Caiman' },
            { id: 40, descripcion: 'Camboya' },
            { id: 41, descripcion: 'Camerun' },
            { id: 42, descripcion: 'Canada' },
            { id: 45, descripcion: 'Chile' },
            { id: 46, descripcion: 'China' },
            { id: 52, descripcion: 'Corea del Norte' },
            { id: 53, descripcion: 'Corea del Sur' },
            { id: 54, descripcion: 'Costa de Marfil' },
            { id: 55, descripcion: 'Costa Rica' },
            { id: 56, descripcion: 'Croacia' },
            { id: 57, descripcion: 'Cuba' },
            { id: 59, descripcion: 'Dinamarca' },
            { id: 61, descripcion: 'Ecuador' },
            { id: 62, descripcion: 'Egipto' },
            { id: 63, descripcion: 'El Salvador' },
            { id: 64, descripcion: 'Emiratos Arabes Unidos' },
            { id: 66, descripcion: 'Eslovaquia' },
            { id: 67, descripcion: 'Eslovenia' },
            { id: 68, descripcion: 'España' },
            { id: 69, descripcion: 'Estados Unidos' },
            { id: 70, descripcion: 'Estonia' },
            { id: 71, descripcion: 'Etiopia' },
            { id: 72, descripcion: 'Islas Feroe' },
            { id: 73, descripcion: 'Filipinas' },
            { id: 74, descripcion: 'Finlandia' },
            { id: 75, descripcion: 'Fiji' },
            { id: 76, descripcion: 'Francia'},
            { id: 83, descripcion: 'Grecia' },
            { id: 84, descripcion: 'Groenlandia' },
            { id: 86, descripcion: 'Guatemala' },
            { id: 87, descripcion: 'Guernsey' },
            { id: 88, descripcion: 'Guinea' },
            { id: 89, descripcion: 'Guinea Ecuatorial' },
            { id: 90, descripcion: 'Guinea-Bissau' },
            { id: 91, descripcion: 'Guyana' },
            { id: 92, descripcion: 'Haiti' },
            { id: 93, descripcion: 'Honduras' },
            { id: 94, descripcion: 'Hong kong' },
            { id: 95, descripcion: 'Hungria' },
            { id: 96, descripcion: 'India' },
            { id: 97, descripcion: 'Indonesia' },
            { id: 98, descripcion: 'Iraq' },
            { id: 99, descripcion: 'Irlanda' },
            { id: 100, descripcion: 'Iran' },
            { id: 101, descripcion: 'Islandia' },
            { id: 102, descripcion: 'Israel' },
            { id: 103, descripcion: 'Italia' },
            { id: 104, descripcion: 'Jamaica' },
            { id: 105, descripcion: 'Japon' },
            { id: 117, descripcion: 'Liberia' },
            { id: 118, descripcion: 'Libia' },
            { id: 120, descripcion: 'Lituania' },
            { id: 121, descripcion: 'Luxemburgo' },
            { id: 122, descripcion: 'Libano' },
            { id: 128, descripcion: 'Maldivas' },
            { id: 129, descripcion: 'Malta' },
            { id: 130, descripcion: 'Islas Malvinas' },
            { id: 131, descripcion: 'Mali' },
            { id: 134, descripcion: 'Marruecos' },
            { id: 144, descripcion: 'Mexico' },
            { id: 145, descripcion: 'Monaco' },
            { id: 146, descripcion: 'Namibia' },
            { id: 147, descripcion: 'Nauru' },
            { id: 149, descripcion: 'Nepal' },
            { id: 150, descripcion: 'Nicaragua' },
            { id: 151, descripcion: 'Nigeria' },
            { id: 152, descripcion: 'Niue' },
            { id: 154, descripcion: 'Noruega' },
            { id: 155, descripcion: 'Nueva Caledonia' },
            { id: 156, descripcion: 'Nueva Zelanda' },
            { id: 157, descripcion: 'Niger' },
            { id: 158, descripcion: 'Oman' },
            { id: 160, descripcion: 'Pakistan' },
            { id: 161, descripcion: 'Palaos' },
            { id: 162, descripcion: 'Palestina' },
            { id: 163, descripcion: 'Panama' },
            { id: 165, descripcion: 'Paraguay' },
            { id: 167, descripcion: 'Peru' },
            { id: 170, descripcion: 'Polonia' },
            { id: 171, descripcion: 'Portugal' },
            { id: 172, descripcion: 'Puerto Rico' },
            { id: 173, descripcion: 'Reino Unido' },
            { id: 175, descripcion: 'Republica Checa' },
            { id: 176, descripcion: 'Republica Dominicana' },
            { id: 178, descripcion: 'Rumania' },
            { id: 179, descripcion: 'Rusia' },
            { id: 197, descripcion: 'Singapur' },
            { id: 198, descripcion: 'Siria' },
            { id: 201, descripcion: 'Sri Lanka' },
            { id: 203, descripcion: 'Sudafrica' },
            { id: 206, descripcion: 'Suecia' },
            { id: 207, descripcion: 'Suiza' },
            { id: 210, descripcion: 'Tailandia' },
            { id: 211, descripcion: 'Taiwan' },
            { id: 219, descripcion: 'Trinidad y Tobajo' },
            { id: 222, descripcion: 'Turquia' },
            { id: 225, descripcion: 'Ucrania' },
            { id: 227, descripcion: 'Uruguay' },
            { id: 230, descripcion: 'Ciudad del Vaticano' },
            { id: 231, descripcion: 'Venezuela' },
            { id: 239, descripcion: 'Chipre' },
            { id: 240, descripcion: 'Guam' },
            { id: 241, descripcion: 'Hawai' },
            { id: 246, descripcion: 'Boniaire' }
          ]; 
          return origenes;
      })
    .catch(this.handleError);
  }   

  getDestino(){        
    let headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
    let url=environment.serviceUrl+'destinos';
    
    return this.http
    .get(url, {headers: headers})
    .toPromise()
    .then(
      response => {
          return response.json() as Destinos;
      },
      reject => {
          let destino = [
            { id: 1, descripcion: 'Sur América' },
            { id: 2, descripcion: 'Centro América' },
            { id: 18, descripcion: 'Costa Rica' },
            { id: 3, descripcion: 'Norte América' },      
            { id: 5, descripcion: 'Europa' },
            { id: 6, descripcion: 'Asia' },
            { id: 7, descripcion: 'África' },
            { id: 8, descripcion: 'Oceanía' },
            { id: 9, descripcion: 'Antillas Holandesas' },
            { id: 10, descripcion: 'Internacional' },
            { id: 11, descripcion: 'Colombia' },
            { id: 13, descripcion: 'PARQUE TAYRONA' },
            { id: 14, descripcion: 'PARQUE NEVADOS' },
            { id: 15, descripcion: 'PARQUE CHINGAZA' },
            { id: 16, descripcion: 'PARQUE IGUAQUE' }
          ];  
          return destino;
      })
    .catch(this.handleError);
  }
  
  getTipo(){        
    let headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
    let url=environment.serviceUrl+'tipoviajes';
    
    return this.http
    .get(url, {headers: headers})
    .toPromise()
    .then(
      response => {
          return response.json() as TiposViaje;
      },
      reject => {
          let tipo = [
            { id: 11, descripcion: 'Estudio' },
            { id: 12, descripcion: 'Larga Estadía (más de 60 días).' },
            { id: 13, descripcion: 'Corta Estadia (menos de 60 días)' },      
            { id: 14, descripcion: 'MultiViajes' },
            { id: 15, descripcion: 'Estudio Con Responsabilidad Civil' },
            { id: 16, descripcion: 'Futura Mamá' },
            { id: 17, descripcion: 'Atención médica por Pre-existencia' },
            { id: 18, descripcion: 'Seguro obligatorio Parques Nacionales' },
            { id: 20, descripcion: 'Seguro de viaje para Deportistas' },
            { id: 21, descripcion: 'Nacional (solo Colombianos o Residentes)' },
            { id: 22, descripcion: 'Francia Turismo / Trabajo'}
          ];  
          return tipo;
      })
    .catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/general/cotizador.service.ts